export const CREATE_NOTIFICATION = '@@notification/CREATE';
export const DELETE_NOTIFICATION = '@@notification/DELETE';
